import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DonorDistributionByRegionChart from "./DonorDistributionByRegionChart";

// Static data for donor distribution by region
const STATIC_REGION_DATA = {
  regions: ["Central", "East", "West", "South", "North"],
  counts: [1450, 1120, 890, 750, 620],
};

const DonorDistributionByRegionWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Donor Distribution by Region")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <DonorDistributionByRegionChart data={STATIC_REGION_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DonorDistributionByRegionWrapper;
